/**
 * Artificial delay to introduce after the completion of a task or the creation of a new document.
 * This is meant to reduce the likelihood of seeing stale data on the UI, due to the asynchronous nature of the external tasks in our workflows.
 */
const ARTIFICIAL_DELAY_DOCUMENT_STATE_UPDATE = 2_500;

export const artificialDelay = <T>(result: T): Promise<T> =>
    new Promise<T>((resolve) => setTimeout(() => resolve(result), ARTIFICIAL_DELAY_DOCUMENT_STATE_UPDATE));
